// i18n-ignore-file — translation overrides (resources)
// CineForge wording on top of the upstream (Moodwalkrs) translations: CineForge makes films,
// not ads. Merged into the default "translation" namespace at startup, so the upstream
// locale files stay untouched. Keys must exist upstream (see textOverrides.test.js).

export const TEXT_OVERRIDES = {
  fr: {
    projectCreate: {
      subtitle: "Pitchez votre idée ou importez un scénario",
      projectNamePlaceholder: "Ex : Les Veilleurs — long métrage",
      describeIdeaPlaceholder:
        "Décrivez votre film...\n\nPar exemple :\n• L'histoire et le propos\n• L'ambiance et le ton souhaités\n• Les personnages et les lieux\n• La durée et le format\n• Les références visuelles ou artistiques",
    },
    briefAnalysis: {
      briefClient: "Scénario / brief",
      startUpload: "Commencez par importer votre scénario ou votre brief pour lancer l'analyse.",
    },
    analysisFields: { advertiser: "Production" },
    onboarding: {
      dashboard: {
        welcome: {
          content:
            "Votre outil de production cinématographique assisté par IA.\n\nIci vous allez pouvoir transformer un scénario ou un brief en film complet, guidé par une équipe créative IA.",
        },
        create: {
          content:
            "Importez un scénario ou un brief (PDF, Word, PPT) ou décrivez votre concept directement. L'IA analysera votre document automatiquement.",
        },
      },
      analysis: {
        intro: {
          content:
            "Cette page permet à l'IA d'analyser votre scénario ou votre brief pour en extraire les éléments clés : histoire, personnages, ton, style visuel...",
        },
      },
      breakdown: {
        intro: {
          content: "L’IA génère un découpage scène par scène avec tous les plans nécessaires à votre film.",
        },
      },
    },
  },
  en: {
    projectCreate: {
      subtitle: "Pitch your idea or import a screenplay",
      projectNamePlaceholder: "E.g.: The Watchers — feature film",
      describeIdeaPlaceholder:
        "Describe your film...\n\nFor example:\n• The story and what it is about\n• The desired mood and tone\n• Characters and locations\n• Duration and format\n• Visual or artistic references",
    },
    briefAnalysis: {
      briefClient: "Screenplay / brief",
      startUpload: "Start by importing your screenplay or brief to launch the analysis.",
    },
    analysisFields: { advertiser: "Production" },
    onboarding: {
      dashboard: {
        welcome: {
          content:
            "Your AI-assisted film production tool.\n\nHere you can turn a screenplay or a brief into a complete film, guided by an AI creative team.",
        },
        create: {
          content:
            "Import a screenplay or a brief (PDF, Word, PPT) or describe your concept directly. The AI will analyze your document automatically.",
        },
      },
      analysis: {
        intro: {
          content:
            "This page lets the AI analyze your screenplay or brief to extract key elements: story, characters, tone, visual style...",
        },
      },
      breakdown: {
        intro: {
          content: "The AI generates a scene-by-scene breakdown with every shot your film needs.",
        },
      },
    },
  },
};

export function applyTextOverrides(i18n) {
  Object.entries(TEXT_OVERRIDES).forEach(([lng, tree]) => {
    i18n.addResourceBundle(lng, "translation", tree, true, true);
  });
}
